import React, { useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import componentFunctions from '../../../../../services/tools/componentFunctions';
import css from './CertificateTable.module.css';

import toShort from '../../../../../services/utils/dateParser'

function CertificateTable({ data, detailsTo }) {
    const [filter, setFilter] = useState('');
    const [showClosed, setShowClosed] = useState(true);
    const [showCancelled, setShowCancelled] = useState(true);
    const [sortConfig, setSortConfig] = useState(componentFunctions.sortConfig);
    const requestSort = (key) => componentFunctions.requestSort(key, sortConfig, setSortConfig);
    const navigate = useNavigate();

    const sortedAndFilteredData = useMemo(() => {
        // let returnedData = componentFunctions.sortedAndFilteredData(data, sortConfig, filter);

        // returnedData.filter((x) => (showClosed ? x.Status !== 'Closed' : true));
        // returnedData.filter((x) => (showCancelled ? x.Status !== 'Closed' : true));

        return componentFunctions
            .sortedAndFilteredData(data, sortConfig, filter)
            .filter((x) => (showClosed ? x.Status !== 'Closed' : true))
            .filter((x) => (showCancelled ? x.Status !== 'Cancelled' : true));
    }, [data, sortConfig, filter, showClosed, showCancelled]);

    if (!data || !data.length) {
        return <p>No data available.</p>;
    }

    // ---------------------------------------
    const headers = Object.keys(data[0]);
    //-------------------------------------

    const handleShowClosedFilter = () => {
        setShowClosed((state) => !state);
    };
    const handleShowCancelledFilter = () => {
        setShowCancelled((state) => !state);
    };

    // console.log(caller);

    return (
        <>
            <div className={css.control}>
                <input
                    type="text"
                    placeholder="Filter results..."
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    className={css.filterInput}
                    //box-shadow: 0 0 8px 0 #54b5f7;
                    // style={{color: isError ? "red" : "black"}}
                />
                <div className={sortedAndFilteredData.length === 0 ? `${css.filterCount} ${css.filterCountZero}` : css.filterCount}>
                    {' '}
                    {sortedAndFilteredData.length}{' '}
                </div>
            </div>
            {/* <div style={{ textAlign: 'right', marginTop: '5px', color: 'red', fontSize: '1.2rem' }}>
                <label>
                    Show Closed?
                    <input type="checkbox" onChange={handleShowClosedFilter} value={showClosed} />
                </label>
                <label>
                    Show Cancelled?
                    <input type="checkbox" onChange={handleShowCancelledFilter} value={showCancelled} />
                </label>
            </div> */}
            <table className={css.table}>
                <thead className={css.thead}>
                    <tr>
                        <th onClick={() => requestSort(data.certificateRef)} className={css.th} style={{ cursor: 'pointer' }}>
                            Ref
                            {sortConfig.key === data.certificateRef ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                        </th>
                        <th onClick={() => requestSort(data.studentName)} className={css.th} style={{ cursor: 'pointer' }}>
                            Student
                            {sortConfig.key === data.studentName ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                        </th>
                        <th onClick={() => requestSort(data.courseNo)} className={css.th} style={{ cursor: 'pointer' }}>
                            Course
                            {sortConfig.key === data.courseNo ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                        </th>
                        <th onClick={() => requestSort(data.certificateStartDate)} className={css.th} style={{ cursor: 'pointer' }}>
                            From
                            {sortConfig.key === data.certificateStartDate ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                        </th>
                        <th onClick={() => requestSort(data.certificateEndDate)} className={css.th} style={{ cursor: 'pointer' }}>
                            To
                            {sortConfig.key === data.certificateEndDate ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                        </th>
                        <th onClick={() => requestSort(data.certificateIssueDate)} className={css.th} style={{ cursor: 'pointer' }}>
                            Issued
                            {sortConfig.key === data.certificateIssueDate ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                        </th>
                        <th onClick={() => requestSort(data.certificateStatus)} className={css.th} style={{ cursor: 'pointer' }}>
                            Status
                            {sortConfig.key === data.certificateStatus ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody className={css.tbody}>
                    {sortedAndFilteredData.length > 0 ? (
                        sortedAndFilteredData.map((x, index) => (
                            <tr
                                key={x.certificateId}
                                id={x.certificateId}
                                onClick={() => navigate(detailsTo + x.certificateId)}
                                className={css.row}
                            >
                                <td className={css.td}>{x.certificateRef}</td>

                                <td className={css.td}>{x.studentName}</td>

                                <td className={css.td}>{x.courseNo}</td>

                                <td className={css.tdWide} style={x.certificateStartDate === '01-Jan-1900' ? { color: 'red' } : {}}>
                                    {toShort(x.certificateStartDate)}
                                </td>
                                <td className={css.tdWide} style={x.certificateEndDate === '01-Jan-1900' ? { color: 'red' } : {}}>
                                    {toShort(x.certificateEndDate)}
                                </td>
                                <td className={css.tdWide} style={x.certificateIssueDate === '01-Jan-1900' ? { color: 'red' } : {}}>
                                    {toShort(x.certificateIssueDate)}
                                </td>

                                <td className={css.td}>{x.certificateStatusTitle}</td>

                                <td className={css.td}>
                                    {x.certificateLink && (
                                        <Link to={x.certificateLink} target="_blank" rel="noopener noreferrer">
                                            <i className="fa-solid fa-award"></i>
                                        </Link>
                                    )}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={headers.length} style={{ textAlign: 'center' }}>
                                No matching records found. Please adjust your filter.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </>
    );
}

export default CertificateTable;
